exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._7Ge9Z_A8glJAPCM8OQ1xf{margin-inline-end:var(--music-spacer-small)}._7Ge9Z_A8glJAPCM8OQ1xf:last-child{margin-inline-end:0}._12yl6gY7_evjyhHEj91p3J{margin-top:var(--music-spacer-small)}@media only screen and (max-width: 700px){._1CVJZLvKl7UMQ1d-xrowZY{display:none}}@media only screen and (min-width: 701px){._3Av3c7_KuAx1kvv4DX9LSL{display:none}}.yhY4Xs6IE5Yh57v_ZDQOm{font-size:1.2em;margin:1em;text-align:center}._3NtpBsrZJXTKBfImASqAxF{font-size:1.2em;margin:2.1em;text-align:center}", ""]);

// exports
exports.locals = {
	"detail-button-slot": "_7Ge9Z_A8glJAPCM8OQ1xf",
	"detailButtonSlot": "_7Ge9Z_A8glJAPCM8OQ1xf",
	"detail-buttons-secondary-row": "_12yl6gY7_evjyhHEj91p3J",
	"detailButtonsSecondaryRow": "_12yl6gY7_evjyhHEj91p3J",
	"empty-texts": "_1CVJZLvKl7UMQ1d-xrowZY",
	"emptyTexts": "_1CVJZLvKl7UMQ1d-xrowZY",
	"empty-texts-vertical": "_3Av3c7_KuAx1kvv4DX9LSL",
	"emptyTextsVertical": "_3Av3c7_KuAx1kvv4DX9LSL",
	"primary-text": "yhY4Xs6IE5Yh57v_ZDQOm",
	"primaryText": "yhY4Xs6IE5Yh57v_ZDQOm",
	"secondary-text": "_3NtpBsrZJXTKBfImASqAxF",
	"secondaryText": "_3NtpBsrZJXTKBfImASqAxF"
};